import {
  GetGameChatroomInfoRequest,
  SubmitGameMissionRequestData,
} from '~/types/missionGameApi';

const missionGameKey = {
  all: ['missionGame'] as const,
  getGameList: () => [...missionGameKey.all, 'mission'] as const,
  getGame: (request: { game_id: number }) =>
    [...missionGameKey.all, 'detail', request.game_id] as const,
  getGameChatroomList: (request: { game_id: number }) =>
    [...missionGameKey.all, 'chatroomList', request.game_id] as const,
  getGameChatroomInfo: (request: GetGameChatroomInfoRequest) =>
    [...missionGameKey.all, 'chatroom', request.game_chat_id] as const,
  getGameResultInfo: (request: SubmitGameMissionRequestData) =>
    [...missionGameKey.all, 'result', { ...request }] as const,
} as const;

export default missionGameKey;
